import React from 'react';
import Select from 'react-select';

const AiReportTypeField = ({
  value,
  onChange,
  options = [],
  styles,
  label = 'AI Report Type',
  placeholder = 'Select report type',
  isClearable = true,
  section = true,
  containerClassName = '',
  itemClassName = 'form-item',
  labelClassName = 'form-section-title-text',
  classNamePrefix,
}) => {
  const selectedOption = options.find((option) => option.value === value) || null;

  const field = (
    <>
      {label ? (
        section ? (
          <div className="form-section-title">
            <span className={labelClassName}>{label}</span>
          </div>
        ) : (
          <div className={labelClassName}>{label}</div>
        )
      ) : null}
      <div className={itemClassName}>
        <Select
          options={options}
          value={selectedOption}
          onChange={(option) => onChange?.(option ? option.value : null)}
          placeholder={placeholder}
          isClearable={isClearable}
          styles={styles}
          classNamePrefix={classNamePrefix}
        />
      </div>
    </>
  );

  if (!section) {
    return <div className={containerClassName}>{field}</div>;
  }

  return <div className={`form-section ${containerClassName}`.trim()}>{field}</div>;
};

export default AiReportTypeField;
